import React from "react";
import styled from "@emotion/styled";
import BasicFormInput from "@components/input/BasicFormInput";
import BasicButton from "@components/button/BasicButton";
import { useTranslation } from "react-i18next";

const FooterContainer = styled.footer(({ theme }) => ({
  position: "fixed",
  bottom: 0,
  display: "flex",
  alignItem: "center",
  justifyContent: "space-between",
  padding: "2rem",
  width: "100%",
  maxWidth: "560px",
  height: "90px",
  backgroundColor: theme.color.white,
  textAlign: "center",
  zIndex: 2,
  boxShadow: " 0px -4px 4px 0px rgba(0, 0, 0, 0.25)",
}));

type Props = {
  selectedQnaId: number | null;
  setSelectedQnaId: React.Dispatch<React.SetStateAction<null | number>>;
};

const ProductQnaInput = ({ selectedQnaId, setSelectedQnaId }: Props) => {
  const { t } = useTranslation();
  return (
    <FooterContainer>
      <BasicFormInput
        name="content"
        placeholder={selectedQnaId === null ? t("문의 남기기") : t("답글달기")}
        max={1000}
      />
      <BasicButton title="등록" type="submit" height="5.2rem" />
    </FooterContainer>
  );
};

export default ProductQnaInput;
